module.exports = __webpack_public_path__ + "img/backyard-garden-and-planter.a59667f8.jpg";